
import {Component, Vue, Prop} from 'vue-property-decorator';
import ServiceContainer from '@flashpointbv/solar-service-container';

@Component({
  name: 'catalog-product-filter-list',
  components: ServiceContainer().getComponents(),
})
export default class extends Vue {
  @Prop({required: true}) readonly dataSource: string;
  @Prop({
    default: () => {
      return [];
    },
  })
  readonly subCategories: Array<object>;
  @Prop() readonly categoryName: string;

  private filterOpen: boolean = ! this.$mobileDetect.mobile();
  private defaultFiltersToShow: number = 5;

  private get filtersToShow(): number {
    return this.subCategories.length > 0 ? this.defaultFiltersToShow - 1 : this.defaultFiltersToShow;
  }

  private get totalProductCount(): number {
    return this.$store.getters[`${this.dataSource}/totalItemCount`];
  }

  private get activeFilters(): Array<object> {
    return this.$store.getters[`${this.dataSource}/activeFilters`];
  }

  private get filterList(): Array<object> {
    return [
      ...(this.$store.getters[`${this.dataSource}/filterList`] || []).filter((f) => f['is_visible'] || f['type'] === 'price'),
    ];
  }

  private get filterListChunks(): Array<object> {
    return this.filterList.map(f => f).splice(0, this.filtersToShow);
  }

  private determineFilterComponent(filter: object): string {
    if (filter['type'] === 'price') {
      return 'catalog-product-list-price-filter';
    }

    if (filter['renderer'] === 'swatch_visual') {
      return 'catalog-product-list-swatch-filter';
    }

    return 'catalog-product-list-attribute-filter';
  }

  private removeFilters(): void {
    this.$store.dispatch(`${this.dataSource}/fetchCatalog`, {filters: []});
  }

  private mounted(): void {
    const placeholder = document.getElementById('filterPlaceholder');
    if (placeholder) {
      placeholder.style.display = 'none';
    }
  }
}
